/**
 * Matches a 3- or 6-digit hex color with an optional leading `#`. Anchored, so
 * it rejects anything with surrounding characters or whitespace. Has no `g`
 * flag, so the instance is safe to share across `.test`/`.exec` calls.
 */
export const HEX_COLOR_REGEX = /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

/** Whether `color` is a clean 3- or 6-digit hex literal (with optional `#`). */
export function isValidHexColor(color: string): boolean {
  return HEX_COLOR_REGEX.test(color);
}
